module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"search":"Suche","selectAll":"Alle auswählen","deselectAllLabel":"Deselect all","filterByContent":"Content","deselectAll":"Deselect all"},"en":{"search":"Search","selectAll":"Select all","deselectAllLabel":"Deselect all","filterByContent":"Content","deselectAll":"Deselect all"}}')
  delete Component.options._Ctor
}
